export const usePopoverToggle = (popover: any, event: Event) => {
  popover.toggle(event);
};

export const usePopoverHide = (popover: any, event: Event) => {
  popover.hide(event);
};

export const usePopoverShow = (popover: any, event: Event) => {
  popover.show(event);
};
